import React, { useEffect, useState } from "react";
interface IProps {
    className?: string;
}
function Slider (props: IProps)  {
    const ref: React.RefObject<HTMLDivElement> = React.createRef();
    const [isOverflow, setIsOverflow] = useState(false);
    const isEllipsisActive = (_e: React.RefObject<HTMLDivElement>) => {
        return false; // ref.current.offsetWidth < ref.current.scrollWidth;
    };
    useEffect(() => {
        addEventListener("resize", () => setIsOverflow(isEllipsisActive(ref)));
    }, []);
    return (
        <div className={[props.className, "slider"].join(' ')}>
            <div ref={ref}>
                {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((i: string, n: number) => {
                    return (<span key={n}>{i}</span>)
                })}
            </div>
            {isOverflow ? "overflow" : "NOT"}
        </div>
    );
};
export default Slider;
